import defaulStringFormatter from './string.js';
export default function symbolFormatter() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    stringFormatter: defaulStringFormatter()
  };
  return function (value) {
    return opts.stringFormatter(value.toString().slice(7, -1));
  };
}